import { call, put, takeLatest } from 'redux-saga/effects';
import { removeProfileApi, removeReportApi, reportDataApi, reportDetailApi, reportListApi } from '../Api/api';
import { toast } from 'react-toastify';
import { removeReportFail, removeReportLoad, removeReportSucees, reportDataFail, reportDataLoad, reportDataSuccess, reportDetailFail, reportDetailLoad, reportDetailSuccess, reportListFail, reportListSuccess, reportListload } from '../slices/report.slice';
import { navigate } from '../../common/navigator'


function* reportDataSaga(action) {
    try {
        const response = yield call(reportDataApi, action.payload);
        if (response?.status == 0) {
            yield put(reportDataSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(reportDataFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(reportDataFail());
    }
}

function* reportListSaga(action) {
    try {
        const response = yield call(reportListApi, action.payload);
        if (response?.status == 0) {
            yield put(reportListSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(reportListFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(reportListFail());
    }
}

function* reportDetailSaga(action) {
    try {
        const response = yield call(reportDetailApi, action.payload);
        if (response?.status == 0) {
            yield put(reportDetailSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(reportDetailFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(reportDetailFail());
    }
}

function* removeReportSaga(action) {
    try {
        const response = yield call(removeReportApi, action.payload);
        if (response?.status == 0) {

                // console.log("calpksdlfjdslijg")
            navigate("/reports");
            toast.success(response?.result?.message)
            

            
            yield put(removeReportSucees());
           
        }
        else {
            toast.error(response?.result?.message)
            yield put(removeReportFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(removeReportFail());
    }
}




function* ReportSaga() {
    yield takeLatest(reportDataLoad.type, reportDataSaga);
    yield takeLatest(reportListload.type, reportListSaga);
    yield takeLatest(reportDetailLoad.type, reportDetailSaga );
    yield takeLatest(removeReportLoad.type, removeReportSaga);
}

export default ReportSaga;